module.exports = __webpack_public_path__ + "static/media/4.3.e73c11f6.png";